import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const Home = lazy(() => import('@/pages/Home'));
const Apps = lazy(() => import('@/pages/Apps'));
const Forbidden = lazy(() => import('@/pages/Forbidden'));
const LoginBoxed = lazy(() => import('@/pages/Authentication/LoginBoxed'));
const ForgotPassword = lazy(() => import('@/pages/Authentication/ForgotPassword'));
const ChangePassword = lazy(() => import('@/pages/Authentication/ChangePassword'));
const AcceptInvite = lazy(() => import('@/pages/Authentication/AcceptInvite'));

const AdminIndex = lazy(() => import('@/pages/Admin/Index'));
const AdminPessoas = lazy(() => import('@/pages/Admin/Pessoas'));
const AdminAcessos = lazy(() => import('@/pages/Admin/Acessos'));
const AdminOrganizacao = lazy(() => import('@/pages/Admin/Organizacao'));
const AdminAuditoria = lazy(() => import('@/pages/Admin/Auditoria'));
const AdminDwMonitor = lazy(() => import('@/pages/Admin/DwMonitor'));
const AdminMcp = lazy(() => import('@/pages/Admin/Mcp'));
const EtlDocsEntrar = lazy(() => import('@/pages/Admin/EtlDocsEntrar'));

// Catálogo do Template Capital: só no build de DEV (`build:local` = --mode development),
// fora do bundle de PROD.
const devRoutes =
    import.meta.env.MODE === 'development'
        ? (() => {
              const DevUi = lazy(() => import('@/pages/DevUi/Index'));
              return [
                  {
                      path: '/dev/ui',
                      element: (
                          <ProtectedRoute>
                              <DevUi />
                          </ProtectedRoute>
                      ),
                  },
              ];
          })()
        : [];

const routes = [
    ...devRoutes,
    {
        // Redireciona home pro hub de apps
        path: '/',
        element: <Navigate to="/apps" replace />,
    },
    {
        path: '/home',
        element: (
            <ProtectedRoute>
                <Home />
            </ProtectedRoute>
        ),
    },
    {
        path: '/apps',
        element: (
            <ProtectedRoute permission="apps.view">
                <Apps />
            </ProtectedRoute>
        ),
    },
    {
        // `/admin` não tem tela própria: manda pra primeira aba que o usuário pode ver.
        path: '/admin',
        element: (
            <ProtectedRoute anyOf={['users.manage', 'roles.manage', 'sectors.manage', 'audit.view', 'pulse.view', 'mcp.manage']}>
                <AdminIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: '/admin/pessoas',
        element: (
            <ProtectedRoute permission="users.manage">
                <AdminPessoas />
            </ProtectedRoute>
        ),
    },
    {
        path: '/admin/acessos',
        element: (
            <ProtectedRoute permission="roles.manage">
                <AdminAcessos />
            </ProtectedRoute>
        ),
    },
    {
        path: '/admin/organizacao',
        element: (
            <ProtectedRoute permission="sectors.manage">
                <AdminOrganizacao />
            </ProtectedRoute>
        ),
    },
    {
        path: '/admin/auditoria',
        element: (
            <ProtectedRoute permission="audit.view">
                <AdminAuditoria />
            </ProtectedRoute>
        ),
    },
    {
        path: '/admin/mcp',
        element: (
            <ProtectedRoute permission="mcp.manage">
                <AdminMcp />
            </ProtectedRoute>
        ),
    },
    {
        path: '/admin/dw',
        element: (
            <ProtectedRoute permission="pulse.view">
                <AdminDwMonitor />
            </ProtectedRoute>
        ),
    },
    {
        // Porta do SSO do dbt docs: o nginx do etldocs.capitalcloud.com.br manda pra cá quem não tem sessão.
        path: '/etldocs/entrar',
        element: (
            <ProtectedRoute permission="etldocs.view">
                <EtlDocsEntrar />
            </ProtectedRoute>
        ),
        layout: 'blank',
    },
    { path: '/admin/users', element: <Navigate to="/admin/pessoas" replace /> },
    { path: '/admin/access-control', element: <Navigate to="/admin/acessos" replace /> },
    { path: '/admin/sectors', element: <Navigate to="/admin/organizacao" replace /> },
    { path: '/admin/audit', element: <Navigate to="/admin/auditoria" replace /> },
    {
        path: '/forbidden',
        element: <Forbidden />,
        layout: 'blank',
    },
    {
        path: '/login',
        element: <LoginBoxed />,
        layout: 'blank',
    },
    {
        path: '/forgot-password',
        element: <ForgotPassword />,
        layout: 'blank',
    },
    {
        path: '/convite/:token',
        element: <AcceptInvite />,
        layout: 'blank',
    },
    {
        path: '/change-password',
        element: (
            <ProtectedRoute>
                <ChangePassword />
            </ProtectedRoute>
        ),
        layout: 'blank',
    },
    {
        // URL que não existe vai pro mesmo lugar de quem não tem permissão
        // (ver `lib/acessoNegado.ts`): de fora, não dá pra saber se a rota existe.
        path: '*',
        element: <Navigate to="/forbidden" replace />,
    },
];

export { routes };
